import {UmpireImageCropParams, UmpireImageCropType} from '@tisa-group/models';
import {InjectionToken} from '@angular/core';

export const CROP_IMAGE_VARIANT_TYPES_CONFIG = new InjectionToken<UmpireImageCropType[]>(
  'Provides crop image variant type config',
);

export const CROP_IMAGE_VARIANT_LABELS_CONFIG = new InjectionToken<
  Partial<Record<UmpireImageCropType, string>>
>('Provides crop image variant labels config');

export const CROP_IMAGE_VARIANT_PARAMS_CONFIG = new InjectionToken<
  Partial<Record<UmpireImageCropType, UmpireImageCropParams>>
>('Provides crop image variant params config');
